import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'isAnyProductSelected'
})
export class IsAnyProductSelectedPipe implements PipeTransform {
  transform(value: {
    products: { qty: number; selected: boolean }[]
  }): boolean {
    if (!value) return false

    return value.products.some((product) => product.selected && product.qty > 0)
  }
}
